/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CloseButton from '../../Buttons/CloseButton';
import './style.scoped.scss';
import $ from 'jquery';

const GlossaryModal = ({
  glossaries,
  selectedKey,
  selectedGlossaryID,
  handleDismiss,
}) => {
  const [selectedGlossary, setSelectedGlossary] = useState(null);
  const [definition, setDefinition] = useState(null);

  // cleanup on dismiss
  useEffect(() => {
    $('#glossaryModal').on('hide.bs.modal', () => {
      handleDismiss();
    });
  }, []);

  const hideModal = () => $('#glossaryModal').modal('hide');

  useEffect(() => {
    if (selectedGlossaryID !== null && glossaries !== null) {
      setSelectedGlossary(
        glossaries.filter((glossary) => glossary.ID === selectedGlossaryID)[0]
      );
    } else if (selectedGlossaryID === null) setSelectedGlossary(null);
  }, [selectedGlossaryID]);

  useEffect(() => {
    if (selectedKey && selectedGlossary) {
      setDefinition(
        selectedGlossary.Content.filter(
          (item) => item.Key === selectedKey
        )[0].Definition.replace(/\\r|\\n/g, '<br />')
      );
    } else if (selectedKey === null) setDefinition(null);
  }, [selectedKey, selectedGlossary]);

  return (
    <div className='modal glossary' id='glossaryModal'>
      <div className='modal-dialog modal-dialog-centered modal-xl'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h2>
              {selectedKey
                ? selectedKey
                : selectedGlossary && selectedGlossary.GlossaryName}
            </h2>
            <CloseButton title='Dismiss Modal' handleClose={hideModal} />
          </div>
          {definition ? (
            <div className='glossary__item p-3'>
              <p
                dangerouslySetInnerHTML={{
                  __html: definition,
                }}
              ></p>
            </div>
          ) : (
            <div className='glossary__content px-3'>
              {selectedGlossary !== null &&
              selectedGlossary.Content.length > 0 ? (
                <table
                  id='content'
                  className='table table-striped table-hover mt-0'
                >
                  <tbody>
                    <tr className='font-weight-bold sticky-top glossary__header-row'>
                      <td>
                        <u>Key</u>
                      </td>
                      <td>
                        <u>Definition</u>
                      </td>
                    </tr>
                    {selectedGlossary.Content.map((item, i) => (
                      <tr key={i}>
                        <td className='glossary__content__key'>{item.Key}</td>
                        <td
                          dangerouslySetInnerHTML={{
                            __html: item.Definition.replace(
                              /\\r|\\n/g,
                              '<br />'
                            ),
                          }}
                        ></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div id='content' className='alert alert-danger mt-4'>
                  No Glossary selected/found.
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  glossaries: state.client.glossaryList,
});

const connector = connect(mapStateToProps, null);

export default connector(GlossaryModal);
